import { DatePipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import { ModuleMenu, SCREEN_RESPONSE, ScreenResponseModel } from 'src/app/models/common';
import { CommonService } from 'src/app/services/common.service';
import { EAPDatashareService } from 'src/app/services/eap/eap-datashare.service';
import { EapSummaryService } from 'src/app/services/eap/eap-summary.service';

@Component({
  selector: 'app-eap-study-team-add-or-role',
  templateUrl: './eap-study-team-add-or-role.component.html',
  styleUrl: './eap-study-team-add-or-role.component.css',
})
export class EapStudyTeamAddOrRoleComponent implements OnInit {

  @Input() public Content: any;
  content: any;
  heading: string;
  action: Subject<any> = new Subject();
  organizationOptions = [];
  roleOptions = [];
  ApplicationID: any;
  RoleName: string = "";
  MemberOrganizationName: string = "";
  organizationgrayout: boolean = true;
  staticformFields: any;
  Application_Type_ID: string = "";
  menudata: ModuleMenu;
  IsFormToched: boolean = false;
  submittedresponse: SCREEN_RESPONSE[] = [];
  permission: any;

  /**
   * Creates an instance of EapStudyTeamAddOrRoleComponent.
   *
   * @param modalRef - Reference to the active modal dialog.
   * @param summaryService - Service for handling summary operations.
   * @param eapDatashareserivse - Service for sharing data across components.
   * @param commonservice - Service providing common utility functions.
   * @param datepipe - Service for date formatting.
   */
  constructor(public modalRef: NgbActiveModal,
    private summaryService: EapSummaryService,
    private eapDatashareserivse: EAPDatashareService,
    private commonservice: CommonService,
    public datepipe: DatePipe,
  ) { }

  /**
   * Initialization code for the component.
   *
   * Subscribes to ApplicationID and Application_Type_ID shared variables and stores the values.
   *
   * If the static form fields are provided in the Content object, iterate over them and set the ControlValue to an empty string.
   *
   * Otherwise, request the static form fields from the server using the GetScreenConfigControls function.
   *
   * Finally, call the bindData function to load the component data.
   */
  ngOnInit() {
    this.eapDatashareserivse.ApplicationID
      .subscribe({
        next: x => {
          this.ApplicationID = x;
        }
      });

    if (this.Application_Type_ID == null || this.Application_Type_ID == undefined || this.Application_Type_ID == "") {
      this.eapDatashareserivse.Application_Type_ID
        .subscribe({
          next: x => {
            this.Application_Type_ID = x;
          }
        });
    }

    if (this.Content?.content?.staticformFields && this.Content?.content?.staticformFields?.length > 0) {
      this.staticformFields = this.Content.content.staticformFields;
      this.staticformFields.forEach((item) => {
        item.ControlValue = ""
      });
    }
    else {
      this.GetScreenConfigControls('SCR-015');
    }
    this.bindData();
  }

  /**
   * Gets the static form fields from the server for the given screen code.
   * Stores the received fields in the staticformFields property.
   * If the fields are not null and have a length greater than 0, filters the fields
   * to only include those with FIELD_CODE equal to 'StudyTeam_Org' or 'StudyTeam_UserRole'.
   * Then calls the bindData function to load the component data.
   * @param screenCode The screen code to get the static form fields for.
   */
  GetScreenConfigControls(screenCode: string) {
    this.commonservice.GetScreenConfigControls(screenCode, this.ApplicationID, this.ApplicationID, (ScreenData) => {
      this.staticformFields = ScreenData["SCREEN_CONTROL"];
      if (this.staticformFields && this.staticformFields.length > 0) {
        this.staticformFields = this.staticformFields.filter(x => x.FIELD_CODE == 'StudyTeam_Org' || x.FIELD_CODE == 'StudyTeam_UserRole');
      }
      this.bindData();
    });
  }

  /**
   * Binds the data to the component controls based on the current heading.
   *
   * If the heading is "view" or "Edit", it binds both dynamic and static data
   * to the controls. Otherwise, it sets the organization grayout flag to false.
   * Finally, it builds the dropdown lists for organization and role options.
   */
  bindData() {
    if (this.Content.heading == "view" || this.Content.heading == "Edit") {
      this.BindDataToDynamicControls();
      this.BindDataToStaticControls(this.Content?.content);
    }
    else {
      this.organizationgrayout = false;
    }
    this.BuildDropdownList();
  }

  /**
   * Builds the dropdown lists for organization and role options.
   *
   * If the static form fields are not null and have a length greater than 0,
   * it sets the organizationOptions and roleOptions properties to the
   * GROUP_VALUES_LIST of the appropriate fields.
   */
  BuildDropdownList() {
    if (this.staticformFields && this.staticformFields.length > 0) {
      this.organizationOptions = this.staticformFields.find(x => x.FIELD_CODE == 'StudyTeam_Org').GROUP_VALUES_LIST;
      this.roleOptions = this.staticformFields.find(x => x.FIELD_CODE == 'StudyTeam_UserRole').GROUP_VALUES_LIST;
    }
  }

  /**
   * Gets the organization name for the given id.
   *
   * It uses the organizationOptions to find the corresponding label for the given id.
   * If the label is found, it is assigned to the MemberOrganizationName property.
   * @param event The event that contains the id.
   */
  getOrganizationName(event) {
    this.MemberOrganizationName = ""
    let id = event.value;
    let obj = this.organizationOptions.filter(function (item) {
      return item.value == id;
    })[0];
    if (obj != null && obj != undefined && obj != "") {
      this.MemberOrganizationName = obj.label;
    }
  }

  /**
   * Gets the role name for the given id.
   *
   * It uses the roleOptions to find the corresponding label for the given id.
   * If the label is found, it is assigned to the RoleName property.
   * @param event The event that contains the id.
   */
  getRoleName(event) {
    this.RoleName = "";
    let id = event.value;
    let obj = this.roleOptions.filter(function (item) {
      return item.value == id;
    })[0];
    if (obj != null && obj != undefined && obj != "") {
      this.RoleName = obj.label;
    }

  }

  /**
   * Validates the controls and then either closes the modal or saves the role organization mapping based on whether the organization and role combination already exists.
   *
   * If the combination already exists and the heading is not "Edit", it displays a validation banner.
   * If the combination already exists and the heading is "Edit", it only closes the modal if the same combination already exists in the row data roles.
   * Otherwise, it creates an object with the selected organization and role ids and names and closes the modal with this object as the result.
   */
  
  SaveRoleOrgMap() {
    if (this.validateControls()) {
      if (this.staticformFields != null && this.staticformFields?.length > 0) {
        let memId: any;
        let roleId: any;
        let orgLabel = "Organization";
        let roleLabel = "User Role";
        this.staticformFields?.forEach((item) => {
          if (item.FIELD_CODE == 'StudyTeam_Org') {
            orgLabel = item.LABEL;
            if (this.organizationOptions && this.organizationOptions.length > 0 && item.ControlValue) {
              memId = this.organizationOptions.find(x => x.value == item.ControlValue).value ?? "";
            }
            else {
              memId = null;
            }
          }
          else if (item.FIELD_CODE === 'StudyTeam_UserRole') {
            roleLabel = item.LABEL;
            if (this.roleOptions && this.roleOptions.length > 0 && item.ControlValue) {
              roleId = this.roleOptions.find(x => x.value == item.ControlValue).value ?? "";
            }
            else {
              roleId = null;
            }
          }
        })

        let isOrgExist = this.Content.content.rowDataRoles.filter(
          (r: any) => { return r.MemberOrganizationId == memId && r.RoleId == roleId })[0];
        if (isOrgExist != null && isOrgExist!=undefined) {
          let message = "";
          if (this.Content?.heading != "Edit") {
            message +=  "A role "+ roleLabel  +" is already added against this " + orgLabel + ". Please select another role <br/>";
            this.commonservice.ValidationBanner(message);
          }
          else {
            let isOrgDExist = this.Content.content.rowDataRoles.findIndex(
              (r: any) => r.MemberOrganizationId == memId && r.RoleId == roleId);
            if (isOrgDExist != -1) {
              this.modalRef.dismiss();
            }
            else {
              let obj = {
                "MemberOrganizationId": memId, "MemberOrganizationName": this.MemberOrganizationName,
                "RoleId": roleId, "RoleName": this.RoleName
              };
              this.modalRef.close(obj);
            }
          }
        }
        else {
          let obj = {
            "MemberOrganizationId": memId,
            "MemberOrganizationName": this.MemberOrganizationName,
            "RoleId": roleId,
            "RoleName": this.RoleName
          };
          this.modalRef.close(obj);
        }
      }
    }
  }

  /**
   * Validates the controls in the static form fields and updates their styles and validation messages.
   *
   * Iterates over the static form fields, checking if each field is mandatory, enabled, and displayed.
   * Depending on the control type, verifies that the field has a valid value. If a field's value is invalid,
   * it updates the field's style to indicate an error and appends an appropriate validation message.
   *
   * The function also handles specific control types that require additional logic, such as aggregating
   * selected items or checking upload files. If any field is invalid, displays a validation banner with
   * all accumulated messages.
   *
   * @returns {boolean} - Returns true if all controls are valid; otherwise, false.
   */
  validateControls(): boolean {
    let isValid = true;
    let message = "";
    this.staticformFields.forEach((item) => {
      if (item.IS_MANDATORY && item.IS_Dependent_Enabled == true && item.IS_Dependent_Display == true) {
        switch (item.CONTROL) {
          case 1:
          case 2:
          case 3:
          case 5:
          case 4:
          case 11:
          case 10:
            if (!item.ControlValue) {
              document.getElementById("dynmcId" + item["ID"]).classList.add(...["ng-touched", "ng-invalid", "validate-error"]);
              document.getElementById("dynmcId" + item["ID"]).classList.remove(...["ng-untouched", "ng-valid"]);

              message += `Please select ${item.LABEL} <br/>`;
              isValid = false;
            }
            break;
          case 6:
            let seletedItem = "";
            for (let c = 0; c < item.SourceItems.length; c++) {
              if (item.SourceItems[c].Checked == true) {
                if (seletedItem == "")
                  seletedItem = item.SourceItems[c].value;
                else
                  seletedItem = seletedItem + "," + item.SourceItems[c].value;
              }
            }
            item.ControlValue = seletedItem;
            if (!item.ControlValue) {
              document.getElementById("dynmcId" + item["ID"]).classList.add(...["ng-touched", "ng-invalid", "validate-error"]);
              document.getElementById("dynmcId" + item["ID"]).classList.remove(...["ng-untouched", "ng-valid"]);
              message += `Please enter ${item.LABEL} <br/>`;
              isValid = false;
            }
            break;
          case 7:
            if (!item.ControlValue) {
              document.getElementById("dynmcId" + item["ID"]).classList.add(...["ng-touched", "ng-invalid", "validate-error"]);
              document.getElementById("dynmcId" + item["ID"]).classList.remove(...["ng-untouched", "ng-valid"]);
              message += `Please enter ${item.LABEL} <br/>`;
              isValid = false;
            }
            break;
          case 8:
            if (item.UploadFiles != null && item.UploadFiles != undefined && item.UploadFiles.length == 0) {
              document.getElementById("dynmcId" + item["ID"]).classList.add(...["ng-touched", "ng-invalid", "validate-error"]);
              document.getElementById("dynmcId" + item["ID"]).classList.remove(...["ng-untouched", "ng-valid"]);
              message += `Please enter ${item.LABEL} <br/>`;
              isValid = false;
            }
            break;
          case 9:
            break;
        }
      }
    });
    if (!isValid)
      this.commonservice.ValidationBanner(message);
    return isValid;
  }

  /**
   * Closes the modal after first checking if the user can exit.
   * If the user has unsaved changes, then a confirmation dialog
   * will be shown before the modal is closed.
   */
  Close() {
    this.canExit().then((x) => {
      this.modalRef.dismiss();
    });
  }

  /**
   * Checks if the user can exit the modal. If the user has unsaved changes,
   * then a confirmation dialog will be shown before the modal is closed.
   *
   * @returns A promise that resolves with true if the user can exit the modal
   * without any further action, or a promise that resolves with false if the
   * user is shown a confirmation dialog before the modal is closed.
   */
  canExit() {
    if (this.IsFormToched && this.Content.heading == 'Edit') {
      return this.commonservice.CanDeactivateBanner();
    }
    else {
      return Promise.resolve(true);
    }
  }

  /**
   * Called when a single option is changed. It will update the parent and child details,
   * and apply any conditions based on the changed option.
   *
   * @param $event The event object containing the changed value.
   * @param question The data model of the question whose value was changed.
   */
  singleonChange($event, question) {
    this.IsFormToched = true;
    if (question.FIELD_CODE == 'StudyTeam_Org') {
      this.getOrganizationName($event)
    }
    else if (question.FIELD_CODE == 'StudyTeam_UserRole') {
      this.getRoleName($event)
    }

    this.UpdateParentChildDetails(question);
    this.ApplyConditions($event, question);
  }

  /**
   * Applies conditions to the controls based on the event value and updates their display, enable, or hide states.
   *
   * @param $event The event object containing the current value to be evaluated against control conditions.
   * @param question The data model of the question that defines conditions and mapped controls.
   *
   * This function processes the control conditions of the given question and determines which controls
   * should be displayed, hidden, enabled, or disabled based on the conditions' mapped values.
   * It updates arrays of control IDs to track the controls' states. The function then iterates through
   * static form fields and updates each control's display and enable properties based on the tracked IDs.
   * Controls with a CONTROL value of "4" will trigger an update of their parent-child details.
   */
  ApplyConditions($event, question) {
    let value = $event.value;
    if (question.Control_Condtions == null || question.Control_Condtions == undefined) {
      question.Control_Condtions = [];
    }
    let displayControlIDS = [];
    let hideControlIDS = [];
    let enableControlIDS = [];
    let disbledControlIDS = [];


    question.Control_Condtions.forEach((item) => {
      if (item.Mapped_Control_Value == value) {
        item.ConditionsList.forEach((otemCon) => {
          switch (otemCon.Mapped_Condtion) {
            case "1": //display
              if (displayControlIDS.length == 0) {
                displayControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
              }
              else {
                let disCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
                if (disCntrIds && disCntrIds.length > 0) {
                  disCntrIds.forEach((id) => {
                    if (!displayControlIDS.includes(id)) {
                      displayControlIDS.push(id);
                    }
                  })
                }
              }

              break;
            case "2": //enabled
              if (enableControlIDS.length == 0) {
                enableControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
              }
              else {
                let enableCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
                if (enableCntrIds && enableCntrIds.length > 0) {
                  enableCntrIds.forEach((id) => {
                    if (!enableControlIDS.includes(id)) {
                      enableControlIDS.push(id);
                    }
                  })
                }
              }
              break;
            case "3": //hide
              if (hideControlIDS.length == 0) {
                hideControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
              }
              else {
                let hideCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
                if (hideCntrIds && hideCntrIds.length > 0) {
                  hideCntrIds.forEach((id) => {
                    if (!hideControlIDS.includes(id)) {
                      hideControlIDS.push(id);
                    }
                  })
                }
              }

              break;

            case "4": //disabled
              if (disbledControlIDS.length == 0) {
                disbledControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
              }
              else {
                let disableCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
                if (disableCntrIds && disableCntrIds.length > 0) {
                  disableCntrIds.forEach((id) => {
                    if (!disbledControlIDS.includes(id)) {
                      disbledControlIDS.push(id);
                    }
                  })
                }
              }
              break;
          }
        });
      }
    });

    //default
    if (value != "") {
      if (this.staticformFields) {
        this.staticformFields.forEach((con) => {

          if (displayControlIDS.indexOf(con.ID) > -1) {
            con.IS_Dependent_Display = true;
            con.ControlValue = "";
            if (con.CONTROL == "10") {
              con.ControlValue = [];
            }
            if (con.CONTROL == "4")
              this.UpdateParentChildDetails(con);
          }
          if (hideControlIDS.indexOf(con.ID) > -1) {
            con.IS_Dependent_Display = false;
            con.ControlValue = "";
            if (con.CONTROL == "10") {
              con.ControlValue = [];
            }
            if (con.CONTROL == "4")
              this.UpdateParentChildDetails(con);
          }
          if (enableControlIDS.indexOf(con.ID) > -1) {
            con.IS_Dependent_Enabled = true;
            con.ControlValue = "";
            if (con.CONTROL == "10") {
              con.ControlValue = [];
            }
            if (con.CONTROL == "4")
              this.UpdateParentChildDetails(con);
          }
          if (disbledControlIDS.indexOf(con.ID) > -1) {
            con.IS_Dependent_Enabled = false;
            con.ControlValue = "";
            if (con.CONTROL == "10") {
              con.ControlValue = [];
            }
            if (con.CONTROL == "4")
              this.UpdateParentChildDetails(con);
          }
        });
      }
    }
  }

  /**
   * UpdateParentChildDetails will update the parent and child details,
   * and apply any conditions based on the changed option.
   *
   * @param question The data model of the question whose value was changed.
   */
  UpdateParentChildDetails(question: any) {
    if (question.Control_Condtions == null || question.Control_Condtions == undefined) {
      question.Control_Condtions = [];
    }
    let displayControlIDS = [];
    let hideControlIDS = [];
    let enableControlIDS = [];
    let disbledControlIDS = [];

    question.Control_Condtions.forEach((item) => {
      item.ConditionsList.forEach((otemCon) => {
        switch (otemCon.Mapped_Condtion) {
          case "1": //display
            if (displayControlIDS.length == 0) {
              displayControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
            }
            else {
              let disCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
              if (disCntrIds && disCntrIds.length > 0) {
                disCntrIds.forEach((id) => {
                  if (!displayControlIDS.includes(id)) {
                    displayControlIDS.push(id);
                  }
                })
              }
            }

            break;
          case "2": //enabled

            if (enableControlIDS.length == 0) {
              enableControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
            }
            else {
              let enableCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
              if (enableCntrIds && enableCntrIds.length > 0) {
                enableCntrIds.forEach((id) => {
                  if (!enableControlIDS.includes(id)) {
                    enableControlIDS.push(id);
                  }
                })
              }
            }
            break;
          case "3": //hide

            if (hideControlIDS.length == 0) {
              hideControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
            }
            else {
              let hideCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
              if (hideCntrIds && hideCntrIds.length > 0) {
                hideCntrIds.forEach((id) => {
                  if (!hideControlIDS.includes(id)) {
                    hideControlIDS.push(id);
                  }
                })
              }
            }
            break;

          case "4": //disabled
            if (disbledControlIDS.length == 0) {
              disbledControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
            }
            else {
              let disableCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
              if (disableCntrIds && disableCntrIds.length > 0) {
                disableCntrIds.forEach((id) => {
                  if (!disbledControlIDS.includes(id)) {
                    disbledControlIDS.push(id);
                  }
                })
              }
            }
            break;
        }
      });
    })
    if (this.staticformFields) {
      this.staticformFields.forEach((con) => {
        if (displayControlIDS.indexOf(con.ID) > -1) {
          con.IS_Dependent_Display = false;
        }
        if (hideControlIDS.indexOf(con.ID) > -1) {
          con.IS_Dependent_Display = true;
        }
        if (enableControlIDS.indexOf(con.ID) > -1) {
          con.IS_Dependent_Enabled = false;
        }
        if (disbledControlIDS.indexOf(con.ID) > -1) {
          con.IS_Dependent_Enabled = true;
        }
      });
    }
  }

  /**
   * Binds the data to the dynamic controls based on the current heading.
   *
   * This function will fetch the submitted response for the given application
   * id and row id, and bind the data to the dynamic controls.
   */
  BindDataToDynamicControls() {
    if (this.ApplicationID != null && this.ApplicationID != undefined && this.ApplicationID != "") {
      let sr = new ScreenResponseModel();
      sr.Id = "SCR-016";
      sr.RowId = this.Content?.content?.id;
      sr.AppId = this.ApplicationID;

      this.summaryService.getEAPScreenResponse(sr)
        .subscribe({
          next: summary => {
            this.submittedresponse = summary;
            if (this.submittedresponse != null && this.submittedresponse.length > 0) {
              for (let i = 0; i < this.staticformFields?.length; i++) {
                let response = this.submittedresponse.filter(x => x.SCREEN_CONTROL_ID == this.staticformFields[i].ID);

                if (response != null && response.length > 0) {
                  if (this.staticformFields[i].CONTROL == '6') {
                    if (response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != null
                      && response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != undefined
                      && response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != "") {
                      this.staticformFields[i].ControlValue = response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER;
                      let options = response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER.split(",");
                      if (this.staticformFields[i].SourceItems != null && this.staticformFields[i].SourceItems != undefined) {
                        for (let c = 0; c < this.staticformFields[i].SourceItems.length; c++) {
                          if (options.indexOf(this.staticformFields[i].SourceItems[c].value) > -1) {
                            this.staticformFields[i].SourceItems[c].Checked = true;
                          }
                          else {
                            this.staticformFields[i].SourceItems[c].Checked = false;
                          }
                        }
                      }
                    }
                  }
                  else if (this.staticformFields[i].CONTROL == '10') {
                    this.staticformFields[i].NotimesChanged = 0;
                    if (response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != null
                      && response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != undefined
                      && response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != "") {
                      this.staticformFields[i].ControlValue = [];

                      let options1 = response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER.split(',');
                      options1.forEach((item) => {
                        this.staticformFields[i].ControlValue.push(item);
                      });
                      this.staticformFields[i].SUBFIELDNAME = response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER;
                    }
                    else {
                      this.staticformFields[i].ControlValue = [];
                    }
                  }
                  else if (this.staticformFields[i].CONTROL == '5') {
                    if (response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != null
                      && response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != ""
                      && response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != undefined) {
                      let formd = new Date(response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER);
                      this.staticformFields[i].ControlValue = formd;
                      if (this.staticformFields[i].DATEFORMATE == 'DD-MMM-YYYY') {
                        let formd = this.commonservice.getdisplayedDate(response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER);
                        this.staticformFields[i].ControlValue = formd;
                      }
                    }
                  }
                  else {
                    this.staticformFields[i].ControlValue = response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER;
                  }
                  this.staticformFields[i].UploadFiles = response[0].UploadFiles;
                  if (this.staticformFields[i].CONTROL == '4') {
                    this.ApplyConditions({ value: this.staticformFields[i].ControlValue }, this.staticformFields[i]);
                  }
                }
              }
            }
          }
        });
    }
  }

  /**
   * Bind the static controls to the given MainObjData
   * @param MainObjData - The object data to be bound to the static controls
   */
  BindDataToStaticControls(MainObjData: any): any {
    for (let i = 0; i < this.staticformFields?.length; i++) {
      switch (this.staticformFields[i].FIELD_CODE) {
        case "StudyTeam_Org":
          this.staticformFields[i].ControlValue = MainObjData.MemberOrganizationId;
          break;
        case "StudyTeam_UserRole":
          this.staticformFields[i].ControlValue = MainObjData.RoleId;
          break;
      }

      if (this.staticformFields[i].CONTROL == '4') {
        this.ApplyConditions({ value: this.staticformFields[i].ControlValue }, this.staticformFields[i]);
      }
    }
    this.MemberOrganizationName = MainObjData.OrganizationName;
    this.RoleName = MainObjData.RoleName;
    this.organizationgrayout = true;
  }

}
